import type { ITodoCategory } from 'core/API/todo';

const GENERAL_CATEGORY_LABEL = 'General';

export const getCategoryLabel = (category: { label?: string; name?: string }): string =>
	category?.label || category?.name || '';

export const getCategoryIri = (category: any): string => {
	if (!category) return '';
	if (typeof category === 'string') return category;
	if (typeof category?.['@id'] === 'string') return category['@id'];
	if (typeof category?.id === 'number') return `/api/todo_categories/${category.id}`;
	return '';
};

/** Prefer "General"; otherwise the oldest category (lowest id). */
export const getDefaultTodoCategory = (categories: ITodoCategory[]): ITodoCategory | null => {
	if (!categories.length) return null;

	const general = categories.find(
		(cat) => getCategoryLabel(cat).toLowerCase() === GENERAL_CATEGORY_LABEL.toLowerCase()
	);
	if (general) return general;

	return [...categories].sort((a, b) => a.id - b.id)[0];
};

export const getDefaultTodoCategoryIri = (categories: ITodoCategory[]): string => {
	const defaultCategory = getDefaultTodoCategory(categories);
	return defaultCategory ? getCategoryIri(defaultCategory) : '';
};
